{
  "notifications": {
    "title": "Notifications",
    "empty": "You have no pending invitations"
  },
  "card": {
    "title": "{{orgName}} · Invitation",
    "subtitle": "{{inviterName}} invited you to join as {{role}}"
  },
  "membersCount_one": "{{count}} member",
  "membersCount_other": "{{count}} members",
  "dialog": {
    "title": "Pending invitation",
    "inviterAction": "has invited you to join the organization",
    "role": "Role: {{role}}",
    "accept": "Accept invitation",
    "reject": "Decline",
    "confirmReject": {
      "title": "Decline invitation?",
      "description": "You won't be able to join this organization unless you receive a new invitation.",
      "confirm": "Decline",
      "cancel": "Cancel"
    }
  },
  "acceptPage": {
    "loading": "Loading invitation...",
    "notFound": "This invitation does not exist or has already been processed.",
    "error": "Could not load the invitation.",
    "expired": "This invitation has expired.",
    "invalid": "This invitation is no longer valid."
  },
  "apiErrors": {
    "acceptConflict": "You are already a member of this organization",
    "acceptNotFound": "The invitation does not exist or has already expired",
    "acceptDefault": "Could not accept the invitation",
    "rejectConflict": "This invitation has already been processed",
    "rejectNotFound": "The invitation does not exist or has already expired",
    "rejectDefault": "Could not decline the invitation"
  }
}
